<template>
  <div>
    <h1 style="width: 0; height: 0; opacity: 0; visibility: hidden; overflow: hidden; margin: 0">
      {{ $t("common.news") }}
    </h1>

    <section class="breadcrumb_nav">
      <div class="breadcrumb_nav_img relative">
        <img src="https://slzx-chengc.oss-cn-shenzhen.aliyuncs.com/sljt-ueeShop/articles/image_1668499027_21.jpg" alt="img" />
        <h2 class="breadcrumb_nav_title text-center hidden-xs">
          {{ $t("common.news") }}
        </h2>
      </div>

      <div class="breadcrumb_nav_wrap">
        <div class="container">
          <div class="row">
            <div class="col-lg-12">
              <div class="breadcrumb_nav_box">
                <ul class="breadcrumb_nav_list">
                  <li>
                    <a href="/">{{ $t("common.home") }}</a>
                  </li>

                  <li>
                    <i class="fa fa-angle-double-right"></i>
                    <span> {{ $t("common.news") }}</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <div id="digood-article">
      <div class="container">
        <div class="row">
          <div class="col-sm-12 digood-article-content" style="padding-top: 50px">
            <div class="row">
              <div class="col-md-9 col-sm-12">
                <div class="digood-article-single" style="padding-bottom: 50px">
                  <div digood-id="article_single_page_1_oyh">
                    <article class="dg-article-wrapper">
                      <div class="dg-thumbnail" style="display: none">
                        <img src="https://slzx-chengc.oss-cn-shenzhen.aliyuncs.com/sljt-ueeShop/articles/image_1666407315_2.jpg" />
                      </div>

                      <div class="dg-header">
                        <h2 class="dg-title">
                          {{ detail.title }}
                        </h2>
                        <div class="dg-metas">
                          <span>{{ detail.createTime }}</span>
                        </div>
                        <hr />
                      </div>
                      <div class="dg-content clearfix img-res" v-html="detail.content"></div>
                    </article>
                  </div>
                  <!-- <div digood-id="article_related_1_oyh" class="recomm_news">
                    <h3 class="title">{{$t('common.viewMore')}}</h3>
                    <div class="clearfix d-flex align-items-center">
                      <div class="post-previous col-md-6 col-sm-6 col-xs-6">
                        <a
                          href="https://www.midonkey.com/article/eurobike-2022.html"
                        >
                          <span class="result">
                            Exhibition In The Place Where The Bicycle Was
                            Invented - Eurobike 2022
                          </span><br/>
                          <span
                            ><i class="fa fa-chevron-left"></i> Previous
                            Post</span
                          >
                        </a>
                      </div>
                      <div
                        class="post-next text-right col-md-6 col-sm-6 col-xs-6"
                      >
                        <a href="javascript:();">
                          <span class="result">No result</span><br/>
                          <span
                            >Next Post <i class="fa fa-chevron-right"></i
                          ></span>
                        </a>
                      </div>
                    </div>
                  </div> -->
                </div>
              </div>
              <div class="col-md-3 col-sm-12">
                <!-- <div class="digood-sidebar-search-box">
                  <div digood-id="common_search_box_1_oyh">
                    <form method="GET" siq_id="autopick_5410">
                      <input type="search" :placeholder="$t('common.search') + '...'" name="keyword" required="required" />
                      <button type="submit">
                        <i class="fa fa-search"></i>
                      </button>
                    </form>
                  </div>
                </div> -->
                <div style="padding-top: 20px"></div>
                <div class="digood-sidebar-nav recruitmentBox">
                  <div digood-id="sidebar_nav_1_oyh">
                    <div class="panel-group" id="digood-module-sidebar-main">
                      <!-- <div
                        class="panel panel-default honorsli-panel"
                        id="industry-news"
                      >
                        <div class="panel-heading top" data-on="">
                          <a
                            class="collapse-link"
                            href="/Articles"
                            style="color: #333"
                            >{{$t('common.industry')}}{{$t('common.news')}}</a
                          >
                        </div>
                      </div> -->
                      <div class="panel panel-default honorsli-panel" id="company-news">
                        <div class="panel-heading top" data-on="">
                          <a class="collapse-link" :href="'/Articles?type=2'" style="color: #333">{{ $t("common.company") }}{{ $t("common.news") }}</a>
                          
                        </div>
                        <div class="panel-heading top" data-on="">
                          <a class="collapse-link" :href="'/Articles?type=1'" style="color: #333">{{ $t("common.industry") }}{{ $t("common.news") }}</a>
                          
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { watch, reactive, onMounted, ref } from "vue"
import i18n from "@/i18n"
import axios from "axios"
import router from "@/router"
import { getArticalInfo } from "@/utils/api"
let detail = ref({})

const getList = () => {
  const route = router.currentRoute
  // axios({
  //   url: `/api/articles-${i18n.locale}.json`,
  //   method: "get"
  // })
  getArticalInfo({language: i18n.locale ,trainingId:route.params.id})
  .then((res) => {  
    if(res.code=='000000'){
      detail.value = res.data
    }  
              
   
  })
}

watch(
  () => i18n.locale,
  (currentValue, prevValue) => {
    getList()
  }
)

onMounted(() => {
  getList()
})
</script>
<style scoped>
[digood-id="common_search_box_1_oyh"] form {
  background: #f7f7f7 none repeat scroll 0 0;
  height: 40px;
  position: relative;
  margin: 0;
}

[digood-id="common_search_box_1_oyh"] input {
  background: transparent none repeat scroll 0 0;
  border: medium none;
  color: #333;
  height: 100%;
  padding: 5px 10px;
  position: absolute;
  top: 0;
  width: 80%;
  outline: medium none;
}

[digood-id="common_search_box_1_oyh"] button {
  background: var(--main-theme-color) none repeat scroll 0 0;
  border: medium none;
  color: #fff;
  height: 100%;
  position: absolute;
  right: 0;
  top: 0;
  width: 20%;
  text-align: center;
  transition: all 0.4s ease 0s;
  padding: 0;
}

[digood-id="common_search_box_1_oyh"] button:hover {
  background: #212121 none repeat scroll 0 0;
}

[digood-id="sidebar_nav_1_oyh"] ul {
  list-style: none;
  margin: 0;
  padding: 0;
  transition: 0.3s;
}

[digood-id="sidebar_nav_1_oyh"] ul ul .collapse-link {
  font-size: 0.9em;
  display: inline;
  padding-left: 1em;
}

[digood-id="sidebar_nav_1_oyh"] ul ul ul .collapse-link {
  padding-left: 2em;
}

[digood-id="sidebar_nav_1_oyh"] .panel {
  margin-top: 0;
  margin-bottom: 0;
  overflow: hidden;
  background-color: transparent;
  box-shadow: none;
}

[digood-id="sidebar_nav_1_oyh"] .panel-group .panel + .panel {
  margin-top: 0;
}

[digood-id="sidebar_nav_1_oyh"] .panel-default {
  border: 0;
}

[digood-id="sidebar_nav_1_oyh"] .panel-heading {
  position: relative;
  border: 1px solid #ddd;
  margin-bottom: 10px;
  padding: 0;
  height: 45px;
  background-color: #fff;
  overflow: hidden;
  border-radius: 0;
}

[digood-id="sidebar_nav_1_oyh"] .panel-heading a {
  color: var(--main-theme-color);
  text-decoration: none;
}

[digood-id="sidebar_nav_1_oyh"] .collapse-link {
  position: absolute;
  z-index: 1;
  display: inline;
  padding: 0;
  top: 50%;
  transform: translate(1em, -50%);
  border: 0;
}

[digood-id="sidebar_nav_1_oyh"] .collapse-button {
  position: absolute;
  left: 0;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  margin: 0;
}

[digood-id="sidebar_nav_1_oyh"] .collapse-button.collapsed .fa {
  transform: rotate(-90deg);
}

[digood-id="sidebar_nav_1_oyh"] .collapse-button > span {
  position: absolute;
  right: 1em;
}

[digood-id="sidebar_related_item_1_oyh"] .dg-media {
  display: flex;
  margin: 5px 0;
}

[digood-id="sidebar_related_item_1_oyh"] .dg-media-body,
[digood-id="sidebar_related_item_1_oyh"] .dg-media-left,
[digood-id="sidebar_related_item_1_oyh"] .dg-media-right {
  vertical-align: middle;
}

[digood-id="sidebar_related_item_1_oyh"] .dg-media-link {
  width: 80px;
  display: block;
}

[digood-id="sidebar_related_item_1_oyh"] .dg-media-link img {
  width: 100%;
}

[digood-id="sidebar_related_item_1_oyh"] .dg-media-heading {
  font-size: inherit;
  padding: 1em;
  margin: 0;
  max-height: 80px;
  overflow: hidden;
}

[digood-id="sidebar_related_item_1_oyh"] .dg-media-heading a {
  color: initial;
  text-decoration: none;
}

[digood-id="sidebar_related_item_1_oyh"] .dg-media-heading a:hover {
  color: var(--main-theme-color);
}

[digood-id="article_single_page_1_oyh"] .dg-article-wrapper {
  border: 1px solid #ddd;
}

[digood-id="article_single_page_1_oyh"] .dg-thumbnail {
  width: 100%;
  text-align: center;
}

[digood-id="article_single_page_1_oyh"] .dg-thumbnail img {
  max-width: 100%;
}

[digood-id="article_single_page_1_oyh"] .dg-title {
  font-size: 20px;
  padding: 10px 20px;
  color: #121212;
}

[digood-id="article_single_page_1_oyh"] .dg-metas {
  padding: 0 20px;
}

[digood-id="article_single_page_1_oyh"] .dg-content {
  padding: 0 20px;
}

[digood-id="article_single_page_1_oyh"] .dg-content p {
  text-indent: 2em;
}

[digood-id="article_single_page_1_oyh"] .dg-footer {
  border-top: 1px solid #ddd;
  padding: 20px 20px;
}

[digood-id="article_related_1_oyh"] {
  border: 1px solid #ddd;
  margin: 1.5em 0;
  padding: 1em 0;
}

[digood-id="article_related_1_oyh"] .title {
  font-size: 20px;
  margin: 0;
  padding: 0 15px 15px 15px;
  border-bottom: 1px solid #ddd;
  margin-bottom: 1em;
}

[digood-id="article_related_1_oyh"] ul {
  list-style: none;
  margin: 0;
  padding: 0;
}

[digood-id="article_related_1_oyh"] ul li {
  line-height: 35px;
}

[digood-id="article_related_1_oyh"] ul li a {
  display: inline-block;
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-decoration: none;
  color: inherit;
}

[digood-id="article_related_1_oyh"] ul li a:hover span {
  color: var(--main-theme-color);
}

@media (max-width: 768px) {
  #digood-article .pull-right {
    float: none !important;
  }
}
</style>
